import getCookieValue from '@utils/helpers/cookie/getCookie';

export function getHandoverParams(search = '') {
  const searchParams = new URLSearchParams(search);
  const query = Object.fromEntries(searchParams);

  const { basketId, biom = '', email, envId, express, jsessionId, monetateId, theme, vid = '' } = query ?? {};

  return {
    basketId: basketId || getCookieValue('basket_id'),
    biom,
    email,
    envId,
    express: express === 'true',
    jsessionId,
    monetateId,
    theme,
    vid,
  };
}
